var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconamoonProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 15.8021C3.33594 14.918 3.68713 14.0702 4.31225 13.4451C4.93737 12.8199 5.78522 12.4688 6.66927 12.4688H13.3359C14.22 12.4688 15.0678 12.8199 15.693 13.4451C16.3181 14.0702 16.6693 14.918 16.6693 15.8021C16.6693 16.2441 16.4937 16.668 16.1811 16.9806C15.8686 17.2932 15.4446 17.4687 15.0026 17.4687H5.0026C4.56058 17.4687 4.13665 17.2932 3.82409 16.9806C3.51153 16.668 3.33594 16.2441 3.33594 15.8021Z",
    stroke: "#323232",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.13281C11.3807 9.13281 12.5 8.01352 12.5 6.63281C12.5 5.2521 11.3807 4.13281 10 4.13281C8.61929 4.13281 7.5 5.2521 7.5 6.63281C7.5 8.01352 8.61929 9.13281 10 9.13281Z",
    stroke: "#323232",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonProfile);
export default __webpack_public_path__ + "static/media/iconamoon_profile.5fc37af4c91dda44bdf47b38a368cff7.svg";
export { ForwardRef as ReactComponent };